import { useEffect } from "react";

const useOnce = (fn: VoidFunction) => {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(fn, []);
};

export default useOnce;